var currentVirtualBranches = [62, 70, 73, 75];
export function isVirtualBranch(branchId) {
    return currentVirtualBranches.indexOf(branchId) !== -1;
}
//# sourceMappingURL=isVirtualBranch.js.map